'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USD_WETH = exports.USD_PETH = exports.USD_MKR = exports.USD_ETH = exports.USD_DAI = exports.USD = exports.WETH = exports.PETH = exports.MKR = exports.ETH = exports.DAI = exports.getCurrency = exports.currencies = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _tokens = require('../../contracts/tokens');

var _tokens2 = _interopRequireDefault(_tokens);

var _lodash = require('lodash.values');

var _lodash2 = _interopRequireDefault(_lodash);

var _currency = require('@makerdao/currency');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currencies = exports.currencies = (0, _lodash2.default)(_tokens2.default).reduce(function (output, symbol) {
  output[symbol] = (0, _currency.createCurrency)(symbol);
  return output;
}, {
  USD: (0, _currency.createCurrency)('USD')
});

var getCurrency = exports.getCurrency = (0, _currency.createGetCurrency)(currencies);

// we export both the currencies object and the individual currencies because
// the latter is convenient when you know what you want to use, and the former
// is convenient when you are picking a currency based on a symbol from input

var DAI = exports.DAI = currencies.DAI;
var ETH = exports.ETH = currencies.ETH;
var MKR = exports.MKR = currencies.MKR;
var PETH = exports.PETH = currencies.PETH;
var WETH = exports.WETH = currencies.WETH;
var USD = exports.USD = currencies.USD;

var USD_DAI = exports.USD_DAI = (0, _currency.createCurrencyRatio)(USD, DAI);
var USD_ETH = exports.USD_ETH = (0, _currency.createCurrencyRatio)(USD, ETH);
var USD_MKR = exports.USD_MKR = (0, _currency.createCurrencyRatio)(USD, MKR);
var USD_PETH = exports.USD_PETH = (0, _currency.createCurrencyRatio)(USD, PETH);
var USD_WETH = exports.USD_WETH = (0, _currency.createCurrencyRatio)(USD, WETH);

(0, _assign2.default)(currencies, {
  USD_DAI: USD_DAI,
  USD_ETH: USD_ETH,
  USD_MKR: USD_MKR,
  USD_PETH: USD_PETH,
  USD_WETH: USD_WETH
});